import * as classNames from 'classnames'
import * as React from 'react'

export interface IHorizontalSelectorItem {
  isSelected?: boolean
  children: any
}

const HorizontalSelectorItemCustom = ({ isSelected = false, children }: IHorizontalSelectorItem) => {
  const itemClasses = classNames({
    'z2 font-small weight-300 font-grey2 pb1 ml2': true,
    'bb-green font-dark-grey': isSelected
  })
  return <div className={itemClasses}>{children}</div>
}

export default HorizontalSelectorItemCustom



// WEBPACK FOOTER //
// ./src/components/products/details/product/details/HorizontalSelectorItemCustom.tsx